// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".colorPaletteItem[data-v-7ba98eef]{height:20px;width:20px;border:1px solid #000}.gradient[data-v-7ba98eef]{width:85%;white-space:nowrap;position:relative;display:inline-block;top:4px;padding-bottom:15px}.grad-step[data-v-7ba98eef]{display:inline-block;height:20px}", ""]);
// Exports
module.exports = exports;
